import { PropsWithChildren, FC } from 'react'
import { Switch } from 'antd'
import Card from '@/pages/Tbqy/components/components/Card'
import Ydtj from './Ydtj'
import Gbmndtj from './Gbmndtj'

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {

  return (
    <Card 
      title={
        <>
          <span className='mr-10'>到款数据统计</span>
          <Switch checkedChildren="含税" unCheckedChildren="不含税" />
        </>
      } 
      hasExport={false}
    >
      <div className='flex mlr-10'>
        <div className='flex-1 w-0' style={{height: '300px'}}>
          <Ydtj updateTime={updateTime} />
        </div>
        <div className='flex-1 w-0 ml-60' style={{height: '300px'}}>
          <Gbmndtj updateTime={updateTime} />
        </div>
      </div>
    </Card>
  )
}

export default Component
